@if (shouldDisplay()) {
    <ui-banner variant="warning">
        <div>
            {{
                'payroll.kyc-kyb.banner.messageReVerificationExpired.0'
                    | translate
                        : {
                              scope: ('payroll.kyc-kyb.scopes.' + scope() | translate),
                              scopeCapitalized: 'payroll.kyc-kyb.scopes.' + scope() | translate | capitalize,
                              date: deadlineDate() | appDate: 'longDate',
                          }
            }}
            <a [routerLink]="linkToPreRedirect">{{
                'payroll.kyc-kyb.banner.messageReVerificationExpired.1' | translate
            }}</a
            >{{ 'payroll.kyc-kyb.banner.messageReVerificationExpired.2' | translate }}
        </div>
    </ui-banner>
}
